import React from 'react';
import Shadow from './shadow';
import Image from './../common/image';
import useMain from '../../hooks/useMain';

function Hero(props) {
	const { theme } = useMain();
	return (
		<>
			<div
				id='hero-carousel'
				className='carousel slide carousel-fade'
				data-bs-ride='carousel'>
				<div className='carousel-indicators'>
					<button
						type='button'
						data-bs-target='#hero-carousel'
						data-bs-slide-to='0'
						className='active'
						aria-current='true'
						aria-label='Slide 1'></button>
					<button
						type='button'
						data-bs-target='#hero-carousel'
						data-bs-slide-to='1'
						aria-label='Slide 2'></button>
					<button
						type='button'
						data-bs-target='#hero-carousel'
						data-bs-slide-to='2'
						aria-label='Slide 3'></button>
				</div>
				<div className='carousel-inner'>
					<div
						className='carousel-item active'
						data-bs-interval='10000'>
						<Hero1 theme={theme} />
					</div>
					<div
						className='carousel-item'
						data-bs-interval='10000'>
						<Hero2 theme={theme} />
					</div>
					<div
						className='carousel-item'
						data-bs-interval='10000'>
						<Hero3 theme={theme} />
					</div>
				</div>
				<button
					className='carousel-control-prev d-none d-md-block'
					type='button'
					data-bs-target='#hero-carousel'
					data-bs-slide='prev'>
					<span
						className='carousel-control-prev-icon'
						aria-hidden='true'></span>
					<span className='visually-hidden'>Previous</span>
				</button>
				<button
					className='carousel-control-next d-none d-md-block'
					type='button'
					data-bs-target='#hero-carousel'
					data-bs-slide='next'>
					<span
						className='carousel-control-next-icon'
						aria-hidden='true'></span>
					<span className='visually-hidden'>Next</span>
				</button>
			</div>
			<Shadow />
		</>
	);
}

const Hero1 = ({ theme }) => {
	return (
		<div
			id='hero_1'
			className='d-block w-100'>
			<div className='container py-md-5'>
				<div className='row align-items-center mb-5'>
					<div className='col-md-5 pt-5 ps-sm-5'>
						<h3 className='pb-4'>
							<b>Empower Your Dreams with MMP WORLD’s Innovative Solutions</b>
						</h3>
						<p>
							At MMP WORLD, we believe in the power of dreams and the unique potential
							within every individual. Our platform opens new doors to invest in what
							you love—from startups and creative ideas to impactful social and
							economic initiatives. We pave the way for turning passions into
							opportunities for growth and meaningful impact. Join us and take part in
							building a better future, one investment at a time.
						</p>
						<Image
							className='w-100 d-block d-md-none'
							fileName={`home/hero_${theme}/1.webp`}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

const Hero2 = ({ theme }) => {
	return (
		<div
			id='hero_2'
			className='d-block w-100'>
			<div className='container py-md-5'>
				<div className='row align-items-center mb-5'>
					<div className='col-md-5 pt-5 ps-sm-5'>
						<h3 className='pb-4'>
							<b>Partner with MMP WORLD to Achieve Financial Success</b>
						</h3>
						<p>
							At MMP WORLD, we go beyond financial services—we walk with you every
							step of the way toward wealth creation, securing your future, and
							achieving ambitious goals. With professional support, expert guidance,
							and personalized investment plans, we help you succeed with confidence
							and clarity. Let us be your trusted partner on your journey to financial
							prosperity.
						</p>
						<Image
							className='w-100 d-block d-md-none'
							fileName={`home/hero_${theme}/2.webp`}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

const Hero3 = ({ theme }) => {
	return (
		<div
			id='hero_3'
			className='d-block w-100'>
			<div className='container py-md-5'>
				<div className='row align-items-center mb-5'>
					<div className='col-md-5 pt-5'>
						<h3 className='pb-4'>
							<b>Join the Crowdfunding Revolution with MMP WORLD</b>
						</h3>
						<p>
							MMP WORLD stands at the forefront of the crowdfunding revolution—where
							investing in groundbreaking ideas and promising ventures is easy,
							accessible, and reward-driven. We’ve created an inclusive environment
							where anyone can contribute to global projects, no matter the investment
							size. Be part of something bigger. Start your journey with us and
							redefine your investment experience.
						</p>
						<Image
							className='w-100 d-block d-md-none'
							fileName={`home/hero_${theme}/3.webp`}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Hero;
